import { Grid, Paper } from '@mui/material';
import styles from "./MinimumSaleTable.module.css";
import {
    Table, TableHead, TableBody, TableRow, TableCell
} from "@mui/material";

const MinimumSaleTable = ({ minimums, formatCurrency, message }) => {

return (
  <Grid item xs={12} md={12} className={styles.container}>
    <Paper className={styles.paper} elevation={2}>
      <Table className={styles.table}>
        <TableHead className={styles.tableHeadRow}>
          <TableRow sx={{ backgroundColor: "primary.main"}} className={styles.tableHeader}>
            <TableCell>Agencia</TableCell>
            <TableCell>Código</TableCell>
            <TableCell>Sorteo</TableCell>
            <TableCell>Mínimo</TableCell>
            <TableCell>Comisión</TableCell>
            <TableCell>Vendido</TableCell>
            <TableCell>Liquidado</TableCell>
            <TableCell>Diferencia</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {minimums.length === 0 ? (
            <TableRow>
              <TableCell colSpan={8} className={styles.emptyMessage}>
                {message || "No minimums available."}
              </TableCell>
            </TableRow>
          ) : (
            minimums.map((minimum, idx) => (
              <TableRow
                key={minimum.id ?? idx}
                className={styles.tableBodyRow}
              >
                <TableCell>{minimum.agencyNumber}</TableCell>
                <TableCell>{minimum.code}</TableCell>
                <TableCell className={styles.bold}>
                  {minimum.raffleNumber}
                </TableCell>
                <TableCell className={styles.bold}>
                  {formatCurrency(minimum.minimum)}
                </TableCell>
                <TableCell>
                  {formatCurrency(minimum.comission)}
                </TableCell>
                <TableCell>
                  {formatCurrency(minimum.sales)}
                </TableCell>
                <TableCell>
                  {formatCurrency(minimum.settledAmount)}
                </TableCell>
                <TableCell>
                  {formatCurrency(minimum.shortfallAmount)}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </Paper>
  </Grid>
);
};

export default MinimumSaleTable;